import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-plugin-raio-x-terms",
  templateUrl: "./plugin-raio-x-terms.component.html",
  styleUrls: ["./plugin-raio-x-terms.component.scss"],
})
export class PluginRaioXTermsComponent implements OnInit {
  currentYear: number;

  constructor(private dialogRef: MatDialogRef<PluginRaioXTermsComponent>) { }

  ngOnInit() {
    this.dialogRef.disableClose = false;
    this.currentYear = new Date().getFullYear();
  }

  close(): void {
    this.dialogRef.close();
  }

}
